import React from 'react';
import { AlertCircle, Phone, FileText, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const EmergencyBanner = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact-form');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact';
    }
  };

  return (
    <section className="py-12 bg-gradient-to-br from-[#2F80ED]/10 via-blue-50 to-[#0B2A4A]/5 border-y border-[#2F80ED]/20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border-2 border-[#2F80ED]/20">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <AlertCircle className="w-6 h-6 text-red-600" />
              </div>
              <div className="flex-1">
                <h2 className="text-2xl md:text-3xl font-bold text-[#0B2A4A] mb-3">
                  Urgence plomberie : fuite, WC bouché, chauffe-eau en panne ?
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Intervention rapide sur Lyon & Grand Lyon. Devis annoncé avant intervention. 
                  Appelez maintenant pour un dépannage d'urgence.
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200">
              <a href={`tel:${companyInfo.phoneFormatted}`} className="flex-1">
                <Button 
                  size="lg" 
                  className="w-full bg-red-600 hover:bg-red-700 text-white gap-2 shadow-lg hover:shadow-xl transition-all duration-300"
                >
                  <Phone className="w-5 h-5" />
                  Appeler maintenant
                </Button>
              </a>
              <Link to="/contact" onClick={scrollToContact} className="flex-1">
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="w-full border-2 border-[#2F80ED] text-[#2F80ED] hover:bg-[#2F80ED] hover:text-white gap-2 transition-all duration-300"
                >
                  <FileText className="w-5 h-5" />
                  Demander un devis
                </Button>
              </Link>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-200 flex flex-wrap items-center justify-center gap-6 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="font-semibold">Disponible 7j/7</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="w-4 h-4 text-[#2F80ED]" />
                <span>Intervention 30-60 min</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#2F80ED]" />
                <span className="font-semibold text-[#2F80ED]">{companyInfo.phone}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmergencyBanner;
